import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const JOURNEY_IMG = "/fira-community.webp";

const HIGHLIGHTS = [
  "VIP Appreciation & Recognition",
  "Celebrating Our Journey",
  "Meet Fira & The Team",
  "Reconnect With The Fira Family",
];

export const Journey = () => (
  <section id="journey" data-testid="journey-section" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <div className="mb-14 flex justify-center">
        <span className="eyebrow">
          The Journey
        </span>
      </div>
      <div className="grid items-center gap-14 md:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
        <h2 className="font-display mt-4 text-4xl font-semibold leading-tight md:text-5xl">
          More Than A Community.
          <br />
          <span className="italic text-fira-rose">We Are Family.</span>
        </h2>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/70 md:text-base">
          <p>Bertahun-tahun kita berkongsi journey yang sama. Daripada sesi trading, market yang mencabar, small win, mistakes dan experience yang membentuk diri kita hari ini.</p>
          <p>Setiap VIP adalah sebahagian daripada perjalanan Fira. Dan kini, Fira nak menghargai mereka yang terus bersama Fira sepanjang perjalanan ini.</p>
          <p className="font-display text-lg italic text-white">This time, it's not just about trading. It's about us.</p>
        </div>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-testid="journey-highlights">
          {HIGHLIGHTS.map((item, i) => (
            <li key={i} className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm">
              <Sparkles className="h-4 w-4 shrink-0 text-fira-rose" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="relative"
      >
        <div className="absolute -inset-4 rounded-3xl bg-fira-pink/20 blur-2xl" />
        <img
          src={JOURNEY_IMG}
          alt="Fira VIP family gathering"
          data-testid="journey-image"
          className="relative w-full rounded-3xl border border-fira-pink/30 object-cover shadow-2xl"
        />
      </motion.div>
      </div>
    </div>
  </section>
);
